import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const ManagePropertiesChart = ({ data }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    const chart = am4core.create("managePropertiesChart", am4charts.PieChart);
    chart.logo.disabled = true;
    chart.innerRadius = am4core.percent(60);

    chart.responsive.enabled = true;
    chart.responsive.useDefault = true;

    if (!data) return;

    const totalUnits = data.occupied + data.vacant;
    const occupiedPercentage = (data.occupied / totalUnits) * 100;
    const vacantPercentage = (data.vacant / totalUnits) * 100;

    chart.data = [
      { category: "Vacant", value:vacantPercentage, color: "#6FD195" },
      { category: "Occupied", value: occupiedPercentage, color: "#7086FD" },
    ];

    // Center label (total)
    const total = chart.data.reduce((sum, item) => sum + item.value, 0);
    const centerLabel = chart.seriesContainer.createChild(am4core.Label);
    centerLabel.text = `${total.toFixed(0)}%`;
    centerLabel.horizontalCenter = "middle";
    centerLabel.verticalCenter = "middle";
    centerLabel.fontSize = 21;
    centerLabel.fontWeight = "bold";
    centerLabel.fill = am4core.color("#404040E5");

    // Pie series
    const series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "category";
    series.slices.template.propertyFields.fill = "color";
    series.ticks.template.propertyFields.stroke = "color";
    series.ticks.template.strokeWidth = 1.5;
    series.ticks.template.strokeOpacity = 1;

    // Label appearance
    series.labels.template.fontSize = 12;
    series.labels.template.fontWeight = 600;
    series.labels.template.radius = am4core.percent(-10); // push labels outside
    series.labels.template.relativeRotation = 0;
    series.labels.template.wrap = false;
    series.labels.template.truncate = false;
    series.labels.template.maxWidth = 120;

    // Adapter to format label text: category + colored % value
    series.labels.template.adapter.add("textOutput", (text, target) => {
      const category = target.dataItem?.category;
      const value = target.dataItem?.value;
      const color = target.dataItem?.dataContext?.color;
      return (
        `[font-size:12px][#00000099]${category}[/]\n` +
        `[font-size:12px][${color}]${value.toFixed(0)}%[/]`
      );
    });

    // Responsive tweaks for small screens
    if (window.innerWidth < 400) {
      chart.innerRadius = am4core.percent(55);
      series.labels.template.fontSize = 8;
    series.labels.template.maxWidth = 100;
    }

    chartRef.current = chart;
    return () => {chart.dispose();};
  }, [data]);

  return (
    <div
      id="managePropertiesChart"
      className="relative w-full h-[300px] sm:min-h-[240px] sm:min-w-[240px]"
    />
  );
};

export default ManagePropertiesChart;
